import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reviews"
}

import { getReviewsContext } from '@/composables/useReviews';

import ReviewFacets from './ReviewFacets.vue';
import ReviewList from './ReviewList.vue';
import ReviewsRatingFacets from './ReviewsRatingFacets.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Reviews',
  setup(__props) {

const { canDisplayReviews } =
  getReviewsContext();

return (_ctx: any,_cache: any) => {
  return (_unref(canDisplayReviews))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ReviewsRatingFacets),
        _createVNode(ReviewFacets),
        _createVNode(ReviewList)
      ]))
    : _createCommentVNode("", true)
}
}

})